import { useTranslation } from 'react-i18next';
import { Addon } from '@domain/addon';
import { useGenericMutation } from '@hooks/use-generic-mutation';
import { useToast } from '@hooks/use-toast/use-toast';
import { useQueryClient } from '@tanstack/react-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { CreateAddonRequest } from './addon-preset.type';
import { QUERY_KEYS } from './constants';

interface CreateEventAddonRequest {
  eventId: string;
  addOnPresetsId?: string[];
  addon?: CreateAddonRequest;
}

const createAddon = async (addonRequest: CreateEventAddonRequest) => {
  const url = `${import.meta.env.VITE_OFFERS_HOST}/v1/nightgraph/add-ons`;

  return request({ url, method: RequestMethod.POST, body: addonRequest });
};

export const useCreateAddons = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const toast = useToast();

  return useGenericMutation<Addon[], RequestError, CreateEventAddonRequest>(
    [QUERY_KEYS.createEventAddon],
    async (addonRequest) => createAddon(addonRequest),
    {
      onSuccess() {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.getAddons],
        });
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.getAddonsPresets],
        });

        toast.push({
          title: t('addons:createAddonNotificationSuccess'),
          text: '',
          type: 'success',
        });
      },
    }
  );
};
